import { render, staticRenderFns } from "./schoolSelect.vue?vue&type=template&id=0fe503d8&scoped=true"
import script from "./schoolSelect.vue?vue&type=script&lang=js"
export * from "./schoolSelect.vue?vue&type=script&lang=js"
import style0 from "./schoolSelect.less?vue&type=style&index=0&id=0fe503d8&lang=less&scoped=true&external"
import style1 from "./schoolSelect.vue?vue&type=style&index=1&id=0fe503d8&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe503d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/b08365e4-b55a-4269-82b4-b5e5a1490008/workspace/hsylc_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fe503d8')) {
      api.createRecord('0fe503d8', component.options)
    } else {
      api.reload('0fe503d8', component.options)
    }
    module.hot.accept("./schoolSelect.vue?vue&type=template&id=0fe503d8&scoped=true", function () {
      api.rerender('0fe503d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/SchoolSelect/schoolSelect.vue"
export default component.exports